import {Component, Directive, NgModule, ElementRef, Renderer2, ViewChild, Input} from '@angular/core'
import {BrowserModule} from '@angular/platform-browser'

@Directive({
  selector: '[stratio]'
})
export class StRatioDirective {
  @Input() stratio;
  constructor (private _elRef: ElementRef, private _renderer: Renderer2) {}
  
  ngOnInit() {
    this._renderer.setAttribute(this._elRef.nativeElement,'width', this.stratio+'%');
  }

}
